
import RegionsTable, { convertRegionResultsToViewItems } from '@/components/Domain.Regions/RegionsTable.vue';
export { convertRegionResultsToViewItems };
import { defineComponent } from 'vue';
export default defineComponent({
    components: { RegionsTable },
    props: { ...RegionsTable.props, title: String },
});
